import {SiteConfigContextValue} from '@common/core/settings/site-config-context';
import {CommonUploadType} from '@common/uploads/common-upload-type';
import {Trans} from '@ui/i18n/trans';
import driveSrc from './admin/verts/drive-top.png';
import landingTopSrc from './admin/verts/landing-top.png';
import filePreviewSrc from './admin/verts/shareable-link.png';
import {FileEntrySharedNotificationRenderer} from './drive/notifications/file-entry-shared-notification-renderer';
import {ShareAccessNotificationRenderer} from './drive/notifications/share-access-notification-renderer';

const fileEntrySharedNotif = 'App\\Notifications\\FileEntrySharedNotif';
const fileRequestUploadNotif = 'App\\Notifications\\FileRequestUploadNotif';
const shareableLinkOpenedNotif =
  'App\\Notifications\\ShareableLinkOpenedNotif';
const shareAccessRequestedNotif =
  'App\\Notifications\\ShareAccessRequestedNotif';
const shareAccessGrantedNotif =
  'App\\Notifications\\ShareAccessGrantedNotif';
const shareAccessDeniedNotif = 'App\\Notifications\\ShareAccessDeniedNotif';

export const SiteConfig: Partial<SiteConfigContextValue> = {
  notifications: {
    renderMap: {
      [fileEntrySharedNotif]: FileEntrySharedNotificationRenderer,
      [fileRequestUploadNotif]: FileEntrySharedNotificationRenderer,
      [shareableLinkOpenedNotif]: FileEntrySharedNotificationRenderer,
      [shareAccessRequestedNotif]: ShareAccessNotificationRenderer,
      [shareAccessGrantedNotif]: FileEntrySharedNotificationRenderer,
      [shareAccessDeniedNotif]: FileEntrySharedNotificationRenderer,
    },
  },
  roles: {
    types: [
      {type: 'users', label: <Trans message="Site roles" />},
      {
        type: 'workspace',
        label: <Trans message="Workspace roles" />,
      },
    ],
  },
  demo: {
    email: 'admin@admin.com',
    password: 'password',
  },
  admin: {
    ads: [
      {
        slot: 'ads.landing-top',
        description: (
          <Trans message="This ad will appear at the top of the landing page." />
        ),
        image: landingTopSrc,
      },
      {
        slot: 'ads.drive',
        description: (
          <Trans message="This ad will appear on user drive page." />
        ),
        image: driveSrc,
      },
      {
        slot: 'ads.file-preview',
        description: (
          <Trans message="This ad will appear on shared file preview page." />
        ),
        image: filePreviewSrc,
      },
    ],
  },
};

export const UploadType = {
  ...CommonUploadType,
  clouddrive: 'clouddrive',
} as const;
